import { doc, getDoc, setDoc, updateDoc, arrayUnion, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';

const COLLECTION = 'appointmentAvailability';

const formatDateKey = (date) => {
  const d = date instanceof Date ? date : new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Public-safe booked slots (time strings only, no patient data).
 */
export const getBookedTimesForDate = async (date) => {
  try {
    if (!db) return [];
    const dateKey = formatDateKey(date);
    const snap = await getDoc(doc(db, COLLECTION, dateKey));
    if (!snap.exists()) return [];
    const data = snap.data();
    return Array.isArray(data.bookedTimes) ? data.bookedTimes : [];
  } catch (error) {
    console.error('Error reading appointment availability:', error);
    return [];
  }
};

/**
 * Reserve a time slot when an appointment is created (no PII stored here).
 */
export const bookTimeSlot = async (date, time) => {
  if (!db || !time) return;
  const dateKey = formatDateKey(date);
  const ref = doc(db, COLLECTION, dateKey);
  const existing = await getDoc(ref);

  if (existing.exists()) {
    const booked = existing.data().bookedTimes || [];
    if (booked.includes(time)) {
      throw new Error('This time slot is no longer available.');
    }
    await updateDoc(ref, {
      bookedTimes: arrayUnion(time),
      updatedAt: Timestamp.now(),
    });
  } else {
    await setDoc(ref, {
      bookedTimes: [time],
      updatedAt: Timestamp.now(),
    });
  }
};

export { formatDateKey };
